// helper functions that enable encryption of the localStorage API.
import { AES, enc } from "crypto-js";

// required environment variable for encryption
const key = enc.Base64.parse(process.env.VUE_APP_KEY);
const iv = enc.Base64.parse(process.env.VUE_APP_IV);

const setItem = (name, payload) => {
  localStorage.setItem(
    AES.encrypt(name, key, { iv: iv }).toString(),
    AES.encrypt(payload, key, { iv: iv }).toString()
  );
};

const getItem = (name) => {
  let localItem = localStorage.getItem(
    AES.encrypt(name, key, { iv: iv }).toString()
  );
  if (localItem === null) {
    return null;
  } else {
    return AES.decrypt(localItem, key, { iv: iv }).toString(enc.Utf8);
  }
};

const removeItem = (name) => {
  localStorage.removeItem(AES.encrypt(name, key, { iv: iv }).toString());
};

export { setItem, getItem, removeItem };
